// extracted by mini-css-extract-plugin
export default {"imageWrapper":"tK-z","twoColumnImage":"uK-z"};